import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import BeneficiaryType from 'models/ImpactPlan/BeneficiaryType';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: { byId: {} },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.BENEFICIARIES_LIST:
      return state.merge(reduxHelper.applyRequestInfo());
    case types.BENEFICIARIES_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: {
            byId: action.payload.results.reduce(
              (obj, beneficiary) => ({
                ...obj,
                [beneficiary.id]: new BeneficiaryType(beneficiary),
              }),
              {}
            ),
          },
        })
      );
    case types.BENEFICIARIES_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
